<template>
    <!-- ContainerHeader.vue -->
    <v-row align="end">
        <!-- Title -->
        <v-col :cols="9" class="py-0">
            <div :class="`font-weight-bold text-h5 text-md-h3 text-xl-h2 ${titleColor}--text`">
                {{ title }}
            </div>
        </v-col>
        <!-- Suffix -->
        <v-col v-if="suffixText" class="py-0" cols="3">
            <div :class="`text-right font-weight-bold text-subtitle text-xl-h6 ${suffixTextColor}--text`">
                {{ suffixText }}
            </div>
        </v-col>
        <!-- Divider -->
        <v-col class="py-0" cols="12">
            <v-divider></v-divider>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'ContainerHeader',
        props: {
            /**
             * The suffix text to display on the right
             */
            suffixText: {
                type: String,
                default: null
            },
            /**
             * The color of the suffix text
             */
            suffixTextColor: {
                type: String,
                default: 'primary'
            },
            /**
             * The title to display
             */
            title: {
                type: String,
                required: true
            },
            /**
             * The color of the title
             */
            titleColor: {
                type: String,
                default: 'primary'
            }
        }
    }
</script>
